// extracted by mini-css-extract-plugin
export var closeButton = "_80-0";